import { useEffect, useRef } from 'react'
import APIS from './APIS'
import { getCurrentUser } from './auth'
import { estCandidatScan } from './videoScan'
import { creerCollecteur, brancherNavigateur, definirCollecteurActif } from './signauxScan'

/* Signaux de passation d'un candidat THE SCAN (13/10/2026), voir utils/signauxScan.js.
   Ne fait rien pour un apprenant THE LAB. Aucun effet visible : un echec d'envoi est ignore. */
const useSignauxScan = (moduleID, ecranID) => {
  const collecteurRef = useRef(null)
  useEffect(() => {
    if (!estCandidatScan(getCurrentUser()) || !moduleID) return
    const collecteur = creerCollecteur({ envoyer: (evenements) => APIS.signauxScan(moduleID, evenements) })
    collecteurRef.current = collecteur
    definirCollecteurActif(collecteur)
    const debrancher = brancherNavigateur(collecteur)
    return () => {
      debrancher()
      collecteur.vider()
      definirCollecteurActif(null)
      collecteurRef.current = null
    }
  }, [moduleID])
  useEffect(() => {
    if (collecteurRef.current && ecranID) collecteurRef.current.ecranAffiche(ecranID)
  }, [ecranID, moduleID])
}

export default useSignauxScan
